import React, { Component } from "react";
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import axios from 'axios';
import { Link } from "react-router-dom";
import { Breadcrumb, Card } from "antd";

import CircularProgress from "components/CircularProgress";
import PageHeader from "components/PageHeader";
import Auxiliary from "util/auxiliary";

class AcceptableUsePolicy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            acceptableUsePolicyData: {},
            errorMessage: null
        }
    }
    componentDidMount() {
        this.setState({
            isLoading: true
        }, () => {
            const AuthStr = 'Bearer '.concat(process.env.REACT_APP_API_TOKEN);
            const INSTANCE = axios.create({
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': AuthStr
                }
            });

            let inputJSON = JSON.stringify({
                type: 'Acceptable Use Policy'
            });

            INSTANCE.post("legal/get-legal", inputJSON)
                .then(response => {
                    if (response.data.messageId === 200) {
                        this.setState({ isLoading: false, acceptableUsePolicyData: response.data });
                    } else {
                        this.setState({ isLoading: false, errorMessage: response.data.message });
                    }
                })
                .catch(error => {
                    this.setState({ isLoading: false, errorMessage: error.message });
                });
        })
    }

    render() {
        const { isLoading, acceptableUsePolicyData } = this.state;
        return (
            <Auxiliary>
                <Row className="margin-bottom">
                    <Col>
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <Link to="/home/dashboard" className="gx-link">Dashboard</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>Acceptable Use Policy</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>
                <PageHeader title="Acceptable Use Policy" navigateTo="/legal/add-acceptable-use-policy" linkName="Add/Edit"/>
                {isLoading ?
                    <div className="gx-loader-view">
                        <CircularProgress />
                    </div> :
                    <Card>
                        <Row>
                            <Col md="12">
                                {
                                    acceptableUsePolicyData.data ?
                                        <div dangerouslySetInnerHTML={{ __html: acceptableUsePolicyData.data.description }} />
                                        : null
                                }
                            </Col>
                        </Row>
                    </Card>
                }
            </Auxiliary >
        );
    }
}

function mapStateToProps(state) {
    return {
        auth: state.auth
    }
}


export default connect(mapStateToProps, null)(AcceptableUsePolicy);
